import React, { FunctionComponent } from "react";
import { Form, Input } from "antd";
import FormLabel from "./FormLabel";
import { QuestionComponentProps } from "../helper";

// TIME_PICKER — placeholder. TODO(v2): build a real antd TimePicker input wired to the form value.
const TimePickerPlaceholder: FunctionComponent<QuestionComponentProps> = ({ question }) => (
  <Form.Item name={question.id} label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}>
    <Input disabled placeholder="Time picker — coming soon" />
  </Form.Item>
);

export default TimePickerPlaceholder;
